(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-collection-tabs';
  var TAB_SELECTOR = '.oddit-section-collection-tabs__tab';
  var PANEL_SELECTOR = '.oddit-section-collection-tabs__grid';
  var ACTIVE_CLASS = 'oddit-section-collection-tabs__tab--active';

  function initSection(section) {
    if (!section || section.dataset.odditTabsInit === 'true') return;
    section.dataset.odditTabsInit = 'true';

    var tabs = section.querySelectorAll(TAB_SELECTOR);
    if (!tabs.length) return;

    var panels = section.querySelectorAll(PANEL_SELECTOR);

    function showPanel(panelId) {
      panels.forEach(function (panel) {
        var show = panel.id === panelId;
        panel.hidden = !show;
        // Reveal animations use an IntersectionObserver that never fires while a
        // panel is hidden, so force the newly-shown panel's cards visible.
        if (show) {
          panel.querySelectorAll('.oddit-reveal').forEach(function (el) {
            el.classList.add('is-visible');
          });
        }
      });
    }

    // Scroll the active tab into view within the (mobile) horizontal tab strip,
    // centering it when possible. Only scrolls the strip, not the page.
    function scrollTabIntoView(targetTab) {
      var list = targetTab.closest('.oddit-section-collection-tabs__tabs');
      if (!list || list.scrollWidth <= list.clientWidth) return;
      var target = targetTab.offsetLeft - (list.clientWidth - targetTab.offsetWidth) / 2;
      list.scrollTo({ left: target, behavior: 'smooth' });
    }

    function setActive(targetTab) {
      tabs.forEach(function (tab) {
        var isActive = tab === targetTab;
        tab.classList.toggle(ACTIVE_CLASS, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      showPanel(targetTab.getAttribute('aria-controls'));
      scrollTabIntoView(targetTab);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(tab);
      });

      tab.addEventListener('keydown', function (e) {
        var currentIndex = Array.prototype.indexOf.call(tabs, tab);
        var nextIndex = -1;

        if (e.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
          nextIndex = 0;
        } else if (e.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex !== -1) {
          e.preventDefault();
          setActive(tabs[nextIndex]);
          tabs[nextIndex].focus();
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();